import { memo, useEffect, FC, useCallback } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from "@chakra-ui/react";
import { TableMetadata } from "../../../types/api/tablemetadata";

type Props = {
  table: TableMetadata | undefined;
  isOpen: boolean;
  onClose: () => void;
};

export const DatacatalogTableModal: FC<Props> = memo((props) => {
  const { isOpen, onClose, table } = props;

  const onModalReset = useCallback(() => {
    if (table) {
    }
  }, [table]);

  useEffect(() => {
    onModalReset();
  }, [table, onModalReset]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onModalReset();
        onClose();
      }}
      motionPreset="slideInBottom"
      autoFocus={false}
      size={"4xl"}
    >
      <ModalOverlay />
      <ModalContent pb={2}>
        <ModalHeader>Table状況</ModalHeader>
        <ModalCloseButton />
        <ModalBody mx={{ base: 0, md: 6 }}>
          <Textarea
            value={JSON.stringify(table, null, 2)}
            readOnly={true}
            rows={20}
            border="1px"
            borderColor={"gray.400"}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
});
